import { render, staticRenderFns } from "./fireFightingLayout.vue?vue&type=template&id=213b8bf0"
import script from "./fireFightingLayout.vue?vue&type=script&lang=js"
export * from "./fireFightingLayout.vue?vue&type=script&lang=js"
import style0 from "./fireFightingLayout.vue?vue&type=style&index=0&id=213b8bf0&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('213b8bf0')) {
      api.createRecord('213b8bf0', component.options)
    } else {
      api.reload('213b8bf0', component.options)
    }
    module.hot.accept("./fireFightingLayout.vue?vue&type=template&id=213b8bf0", function () {
      api.rerender('213b8bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/layout/fireFightingLayout.vue"
export default component.exports